import {Button, Card, Empty, Result, Skeleton, Table, Tag} from "antd"
import React, {useEffect} from "react"
import DisplayResult from "../../../util/DisplayResult"
import {useClubCleanTableRecordContext} from "../store/useClubCleanTableRecordContext"
import moment from "moment"

const ClubCleanTableRecordTable = () => {

    const {
        cleanRecordListState,
        pageState,
        onPageChange,
        getCleanRecordList,
        exportCleanRecordList
    } = useClubCleanTableRecordContext()

    useEffect(() => {
        getCleanRecordList()
    }, [])

    return (
        <div>
            <Card title={"打扫记录"}
                  extra={
                      <Button type={"primary"} onClick={exportCleanRecordList}>
                          导出
                      </Button>
                  }
            >
                <div>
                    <DisplayResult state={cleanRecordListState}
                                   onIdle={() => {
                                       return <div>
                                           <Result
                                               status={"info"}
                                               title={"暂无数据"}
                                           />
                                       </div>
                                   }}
                                   onLoading={
                                       () => {
                                           return <div>
                                               <Skeleton active></Skeleton>
                                           </div>
                                       }
                                   }
                                   onError={(errorMessage) => {
                                       return <div>
                                           <Result
                                               status={"error"}
                                               title={"获取数据失败"}
                                               subTitle={errorMessage}
                                           />
                                       </div>
                                   }}
                                   onSuccess={(data) => {
                                       return <div>
                                           <Table
                                               columns={columns}
                                               dataSource={data}
                                               bordered
                                               pagination={{
                                                   total: pageState.total,
                                                   current: pageState.page,
                                                   pageSize: pageState.count,
                                                   onChange: (page, pageSize) => {
                                                       onPageChange(page, pageSize)
                                                   }
                                               }}
                                           />
                                       </div>
                                   }}
                                   onEmpty={<div>
                                       <Empty></Empty>
                                   </div>}
                    />
                </div>
            </Card>
        </div>
    )
}

const columns = [
    {
        title: '桌台名称',
        dataIndex: 'table_name',
        key: 'table_name',
    },
    {
        title: '开始时间',
        dataIndex: 'start_time',
        key: 'start_time',
    },
    {
        title: '结束时间',
        dataIndex: 'end_time',
        key: 'end_time',
    },
    {
        title: '使用时长',
        dataIndex: 'use_duration',
        key: 'use_duration',
        render: (text) => {
            return moment.utc(text * 1000).format('HH:mm:ss')
        }

    },
    {
        title: '结束方式',
        dataIndex: 'type',
        key: 'type',
        render: (text) => {
            switch (parseInt(text)) {
                case 1:
                    return <Tag color={'blue'}>自动</Tag>
                case 2:
                    return <Tag color={'green'}>手动</Tag>
            }
        }
    },
    {
        title: '操作人',
        dataIndex: 'employee_name',
        key: 'employee_name',
    },
    {
        title: '来源',
        dataIndex: 'source',
        key: 'source',
        render: (text) => {
            switch (parseInt(text)) {
                case -1:
                    return <Tag color={'default'}>未知来源</Tag>
                case 1:
                    return <Tag color={'blue'}>收银端</Tag>
                case 32:
                    return <Tag color={'green'}>掌上管家</Tag>
            }
        }
    },
]

export default ClubCleanTableRecordTable


// WEBPACK FOOTER //
// ./src/containers/ClubCleanTableRecord/component/ClubCleanTableRecordTable.js